import APIController from '../core-api-controller';

export const fetchAllNotifications = (paramsObj = {}, paramsStr = '') => {
  const path = `${APIController.endpointApi}/notifications${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const fetchUnreadNotificationCount = () => {
  const path = `${APIController.endpointApi}/users/unread_notifications_count`;
  return APIController.getApiCallback(path);
};

export const markNotificationRead = (id = '', data = {}) => {
  const path = `${APIController.endpointApi}/notifications/${id}`;
  return APIController.putCallback(path, data);
};

export const markAllNotificationReadApi = (data = {}) => {
  const path = `${APIController.endpointApi}/users/mark_notifications_as_read`;
  return APIController.postCallback(path, data);
};
